import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
// css
import styles from "./ViewFiles.module.scss";
import { CloseIcon } from "Assets/icons";
import { CommonToolTip } from "components/Common/Common";
import { truncateUrl } from "helpers/common";
import { generatePath, useNavigate } from "react-router-dom";
import { DOCUMENT_PDF_VIEW } from "config/paths";

const ShowAttachedFilesPop = ({ files = [], show, setShow }) => {

    const handlePopup = () => setShow(!show);
    const navigate = useNavigate()

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">All Attached Files</h6>

                    </div>
                    <Row>
                        <Col lg="12" className="my-2">
                            <ul className="list-unstyled ps-0 mb-0">
                                {
                                    files?.map((item, index) => {
                                        return (
                                            <li className="py-2" key={index}>
                                                <div className="d-flex align-items-center justify-content-between gap-10">
                                                    <div className="left d-flex align-items-center gap-10">
                                                        <div className="content d-flex align-items-center">

                                                            <svg style={{ marginRight: "10px" }} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="15" cy="15" r="15" fill="#AC5C9A" fill-opacity="0.2" />
                                                                <mask id="mask0_3507_16365" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="7" y="7" width="16" height="16">
                                                                    <rect x="7" y="7" width="16" height="16" fill="#D9D9D9" />
                                                                </mask>
                                                                <g mask="url(#mask0_3507_16365)">
                                                                    <path d="M12.3337 14.9997V13.6663H17.667V14.9997H12.3337ZM12.3337 12.333V10.9997H17.667V12.333H12.3337ZM11.0003 16.333H16.0003C16.3225 16.333 16.6225 16.4025 16.9003 16.5413C17.1781 16.6802 17.4114 16.8775 17.6003 17.133L19.0003 18.9663V9.66634H11.0003V16.333ZM11.0003 20.333H18.367L16.5503 17.9497C16.4837 17.8608 16.4031 17.7913 16.3087 17.7413C16.2142 17.6913 16.1114 17.6663 16.0003 17.6663H11.0003V20.333ZM19.0003 21.6663H11.0003C10.6337 21.6663 10.3198 21.5358 10.0587 21.2747C9.79755 21.0136 9.66699 20.6997 9.66699 20.333V9.66634C9.66699 9.29967 9.79755 8.98579 10.0587 8.72467C10.3198 8.46356 10.6337 8.33301 11.0003 8.33301H19.0003C19.367 8.33301 19.6809 8.46356 19.942 8.72467C20.2031 8.98579 20.3337 9.29967 20.3337 9.66634V20.333C20.3337 20.6997 20.2031 21.0136 19.942 21.2747C19.6809 21.5358 19.367 21.6663 19.0003 21.6663Z" fill="#B46C9F" />
                                                                </g>
                                                            </svg>

                                                            <CommonToolTip
                                                                component={<h6
                                                                    style={{
                                                                        textOverflow: "ellipsis",
                                                                        overflow: "hidden",
                                                                        fontSize: "14px",
                                                                    }}
                                                                    className="m-0 fw-bold themeBlue"
                                                                >
                                                                    {truncateUrl(item?.attachment_name, 40)}
                                                                </h6>}
                                                                text={decodeURIComponent(item?.attachment_name)}
                                                            />


                                                        </div>
                                                    </div>
                                                    <div className="right">
                                                        <Button
                                                            style={{ minWidth: "unset", fontSize: "12px" }}
                                                            className="d-flex align-items-center justify-content-center commonBtn h-auto"
                                                            onClick={() => navigate(generatePath(DOCUMENT_PDF_VIEW, { attachmentKey: item.attachment_key }))}
                                                        >
                                                            <span className="icn me-1">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="11"
                                                                    viewBox="0 0 16 11"
                                                                    fill="none"
                                                                >
                                                                    <path
                                                                        d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
                                                                        fill="white"
                                                                    />
                                                                </svg>
                                                            </span>
                                                            View
                                                        </Button>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default ShowAttachedFilesPop;



const searchIcn = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38144 0.235352 8.05579 0.235352 6.48936C0.235352 4.92308 0.777789 3.59697 1.86266 2.51103C2.94754 1.42524 4.27319 0.882339 5.83962 0.882339C7.4059 0.882339 8.73201 1.42493 9.81796 2.51011C10.9037 3.59529 11.4466 4.92125 11.4466 6.48799C11.4466 7.14264 11.3368 7.76788 11.1171 8.36372C10.8973 8.95955 10.604 9.47777 10.2373 9.91838L15.228 14.6076L14.2621 15.5737ZM5.841 10.7189C7.02212 10.7189 8.02251 10.309 8.84216 9.48915C9.66197 8.6695 10.0719 7.66911 10.0719 6.48799C10.0719 5.30686 9.66197 4.30647 8.84216 3.48682C8.02251 2.66701 7.02212 2.25711 5.841 2.25711C4.65987 2.25711 3.65948 2.66701 2.83983 3.48682C2.02003 4.30647 1.61012 5.30686 1.61012 6.48799C1.61012 7.66911 2.02003 8.6695 2.83983 9.48915C3.65948 10.309 4.65987 10.7189 5.841 10.7189Z" fill="#1C1B1F" />
</svg>


const serviceOptions = [
    {
        value: "",
        label: "All Services",
    },
    {
        value: "school",
        label: "School",
    },
    {
        value: "home_education",
        label: "Home Education",
    },
    {
        value: "chatter",
        label: "Chatter",
    },
    {
        value: "private",
        label: "Private",
    }
];